import { t } from '@lingui/macro'
import { skipToken } from '@tanstack/react-query'
import Debug from 'debug'
import { useParams } from 'react-router-dom'
import { bizApi } from '../BizApi'
import { BizUserForm } from '../components/BizUserForm'
import { BizWidget } from '../widgets/BizWidget'
import { cn } from '@jotta/utils/css'

export const debug = Debug('jotta:biz:BizModifyUserRoute')

export function BizUserEditRoute() {
  const { username = '' } = useParams()
  const query = bizApi.user.byId.useSuspenseQuery({
    variables: username ? { username } : skipToken,
  })
  return (
    <BizWidget
      title={username ? t`Modify user` : t`Create new user `}
      className="w-full"
      bodyClassName={cn('max-w-2xl')}
    >
      <BizUserForm mode="edit" user={query.data} />
    </BizWidget>
  )
}
